<template>
	<div class="b-icon" v-on="$listeners">
		<component class="b-icon__icon" :style="styleVal" :is="name" />
	</div>
</template>

<script>
import AddAlt from "./icons/Add alt.vue";
import Add from "./icons/Add.vue";
import ArrowLeft from "./icons/ArrowLeft.vue";
import CaretDown from "./icons/Caret down.vue";
import CaretUp from "./icons/Caret up.vue";
import Checkmark from "./icons/Checkmark.vue";
import CheckmarkOutline from "./icons/CheckmarkOutline.vue";
import ICircle from "./icons/ICircle.vue";
import CloseFilled from "./icons/Close filled.vue";
import Close from "./icons/Close.vue";
import Delete from "./icons/Delete.vue";
import Download from "./icons/Download.vue";
import Dragg from "./icons/Dragg.vue";
import DrawHide from "./icons/Draw Hide.vue";
import DrawShow from "./icons/Draw Show.vue";
import Draw from "./icons/Draw.vue";
import Duplicate from "./icons/Duplicate.vue";
import Edit from "./icons/Edit.vue";
import Error from "./icons/Error.vue";
import History from "./icons/History.vue";
import List from "./icons/List.vue";
import Maximize from "./icons/Maximize.vue";
import Minimize from "./icons/Minimize.vue";
import OverflowVertical from "./icons/Overflow vertical.vue";
import Placeholder from "./icons/Placeholder.vue";
import Reset from "./icons/Reset.vue";
import Save from "./icons/Save.vue";
import Send from "./icons/Send.vue";
import Subtract from "./icons/Subtract.vue";
import Warning from "./icons/Warning.vue";
import IWindmill from "./icons/IWindmill.vue";
import IBridge from "./icons/IBridge.vue";
import IDocument from "./icons/IDocument.vue";
import IPlaceholder from "./icons/IPlaceholder.vue";
import ITime from "./icons/ITime.vue";
import Search from "./icons/Search.vue";
import ArrowDown from "./icons/ArrowDown.vue";
import Menu from "./icons/Menu.vue";

export default {
	props: {
		name: {
			type: String,
			required: true,
		},
		size: {
			type: [String, Number],
			default: null,
		},
	},
	components: {
		AddAlt,
		Add,
		ArrowLeft,
		CaretDown,
		CaretUp,
		Checkmark,
		CheckmarkOutline,
		ICircle,
		CloseFilled,
		Close,
		Delete,
		Download,
		Dragg,
		DrawHide,
		DrawShow,
		Draw,
		Duplicate,
		Edit,
		Error,
		History,
		List,
		Maximize,
		Minimize,
		OverflowVertical,
		Placeholder,
		Reset,
		Save,
		Send,
		Subtract,
		Warning,
		IWindmill,
		IBridge,
		IDocument,
		IPlaceholder,
		ITime,
		Search,
		ArrowDown,
		Menu,
	},
	computed: {
		styleVal() {
			return {
				width: this.size,
				height: this.size,
			};
		},
	},
};
</script>

<style>
.b-icon__icon {
	display: block;
}
</style>
